(function (angular) {
    'use strict';

    angular.module('customChannel')
        /**
         *
         */
        .controller('CustomChannelsCtrl',
            ['$scope', '$rootScope', '$timeout','customChannelService', '$stateParams',  'growlService', 'customChannelsData', 'profileSchema', '$uibModalInstance', 'channelId',
                function ($scope, $rootScope, $timeout, customChannelService, $stateParams,  growlService, customChannelsData, profileSchema, $uibModalInstance, channelId) {

                    var vm = this;

                    $scope.channelId = channelId;

                    $scope.$on('wizard:stepChanged', function (event, args) {
                        if (args.index === 3) {
                            $timeout(function () {
                                var cm = angular.element(document.querySelector('.CodeMirror'));
                                if (cm[0]) {
                                    cm[0].CodeMirror.refresh();
                                }
                            }, 0);
                        }
                    });

                    $scope.editorOptions = {
                        lineWrapping: true,
                        theme: "panda-syntax",
                        autofocus: true,
                        lineNumbers: true,
                        mode: { name: "javascript", json: true }
                    };

                    vm.fistStepCanEnter = function () {
                        return true;
                    };

                    vm.firstStepExitValidation = function () {
                        //canexit require true/false
                        return !!($scope.newCustomChannel && $scope.newCustomChannel.verb && vm.CustomChannelFirstStepForm.$valid);
                    };

                    vm.secondStepExitValidation = function () {
                        return vm.firstStepExitValidation() && vm.CustomChannelSecondStepForm.$valid;
                    };

                    vm.thirdStepExitValidation = function () {
                        return vm.secondStepExitValidation() && vm.CustomChannelThirdStepForm.$valid;
                    };

                    vm.fourthStepExitValidation = function () {
                        //canexit require true/false
                        return !!(vm.thirdStepExitValidation() && $scope.newCustomChannel && $scope.newCustomChannel.bodyTemplate);
                    }

                    $scope.httpMethods = ['GET','POST','PUT','DELETE'];

                    $scope.setUp = function setUp() {
                        
                        if ($scope.channelId) {
                            var customChannel = _.find(customChannelsData, { id: $scope.channelId });

                            if (customChannel) {
                                $scope.newCustomChannel = {
                                    id: customChannel.id,
                                    name: customChannel.name,
                                    url: customChannel.url,
                                    verb: customChannel.verb,
                                    contentType: customChannel.contentType
                                };

                                if (customChannel.bodyTemplate) $scope.newCustomChannel.bodyTemplate = customChannel.bodyTemplate;
                                if (customChannel.idFieldName) $scope.newCustomChannel.idFieldName = customChannel.idFieldName;

                                var headers = [];
                                for (var i in customChannel.headers) {
                                    headers.push([i, customChannel.headers[i]]);
                                }
                                if (headers.length === 0) headers.push([]);
                                $scope.newCustomChannel.headers = headers;

                                if (customChannel.authentication && customChannel.authentication.basic) {
                                    $scope.newCustomChannel.authType = 'basic';
                                    $scope.newCustomChannel.username = customChannel.authentication.basic.username;
                                    $scope.newCustomChannel.password = customChannel.authentication.basic.password;
                                }
                                else if (customChannel.authentication && customChannel.authentication.bearer) {
                                    $scope.newCustomChannel.authType = 'bearer';
                                    $scope.newCustomChannel.bearer = customChannel.authentication.bearer;
                                }
                                else {
                                    $scope.newCustomChannel.authType = 'none';
                                }
                                $scope.editing = true;
                            }
                            
                            
                        } else {
                            $scope.newCustomChannel = {
                                headers: [[]]
                            };
                            $scope.newCustomChannel.authType = 'none';
                        }
                    };
               
                    $scope.setUp();

                    $scope.profileSchema = profileSchema;

                    $scope.customChannelsData = customChannelsData;

                    $scope.updateCustomChannel = function (channel, newChannel) {
                        var index = $scope.customChannelsData.indexOf(channel);
                        $scope.customChannelsData[index] = newChannel;
                    };

                    $scope.addHeader = function () {
                        $scope.newCustomChannel.headers.push([]);
                    };

                    $scope.deleteHeader = function (index) {
                        if ($scope.newCustomChannel.headers.length == 1) {
                            $scope.newCustomChannel.headers = [[]];
                        }
                        else {
                            $scope.newCustomChannel.headers.splice(index, 1);
                        }
                    };

                    $scope.acceptCreating = function () {
                        var data = {
                            name: $scope.newCustomChannel.name,
                            url: $scope.newCustomChannel.url,
                            verb: $scope.newCustomChannel.verb.toLowerCase(),
                            contentType: $scope.newCustomChannel.contentType
                        };
                        if ($scope.newCustomChannel.bodyTemplate) data.bodyTemplate = $scope.newCustomChannel.bodyTemplate;
                        if ($scope.newCustomChannel.idFieldName) data.idFieldName = $scope.newCustomChannel.idFieldName;
                        var headers = {};
                        for (var i in $scope.newCustomChannel.headers) {
                            if ($scope.newCustomChannel.headers[i][0] && $scope.newCustomChannel.headers[i][1]) {
                                headers[$scope.newCustomChannel.headers[i][0]] = $scope.newCustomChannel.headers[i][1];
                            }
                        }
                        if (Object.keys(headers).length > 0) data.headers = headers;
                        if ($scope.newCustomChannel.authType == 'basic') {
                            data.authentication = {
                                basic: {
                                    username: $scope.newCustomChannel.username,
                                    password: $scope.newCustomChannel.password
                                }
                            };
                        }
                        else if ($scope.newCustomChannel.authType == 'bearer') {
                            data.authentication = {
                                bearer: $scope.newCustomChannel.bearer
                            };
                        }
                        if ($scope.channelId) {
                            data.id = $scope.channelId;
                            customChannelService.updateCustomChannel($stateParams.pickedApiSpaceId, data).then(function (ret) {
                                growlService.success('custom channel updated');
                                $uibModalInstance.close('channel updated');
                            }).catch(function (error) {
                                growlService.danger("custom channel wasn't updated due to: " + error.statusText);
                            });
                         } else {
                            customChannelService.createCustomChannel($stateParams.pickedApiSpaceId, data).then(function (response) {
                                growlService.success('Custom Channel created');
                                $uibModalInstance.close('channel created');
                                $rootScope.$broadcast('Custom channel created', response);

                            }).catch(function (error) {
                                growlService.danger("Custom Channel wasn't created due to: " + error.statusText);
                            });
                        }
                      
                      
                    };

                    $scope.cancelCreating = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }]);


})(window.angular);
